import axios from "axios";
import { baseURL } from "configurations/environment";
import { RequestConfig } from "helpers/RequestConfig";


export const getRCapiAuthUrl = async ():Promise<{
    status: boolean,
    data: string,
    message?:string,
}> => {
    try {
        let requestURL = baseURL + `/api/destinations/rd/auth-url`;

        const response = await axios.get<{
         data: {
            url?: string,
         }
        }>(requestURL, RequestConfig());
        return {
            status: true,
            data: response.data?.data?.url,
        };
    } catch (error) {
        return {
            status: false,
            data: error.data,
        };
    }
};

export const authorizeRCapi = async (payload: {
    code: string,
}):Promise<{
    status: boolean,
    data: {
        partner_id: number,
        advertisers: [
        {
          id: number,
          name: string,
        }
        ][]
      },
    message?:string,
}> => {
    try {
        let requestURL = baseURL + `/api/destinations/rd/authorize`;

        const response = await axios.post<{
         data:  {
            partner_id: number,
            advertisers: [
            {
              id: number,
              name: string,
            }
            ][]
        },
        }>(requestURL, payload, RequestConfig());

        return {
            status: true,
            data: response.data?.data,
        };
    } catch (error) {
        return {
            status: false,
            data: error.data,
        };
    }
};